<script>
export default {
  name: "KolonneSettingsAssignedEmployee",

  props: {
    employee: {
      type: Object | null,
      default: null
    },
    selectedKolonneId: {
      type: Number | String,
      default: ''
    },
    startdate: {
      type: String, // format "YYYY-MM-DD"
      default: '',
    },
    kolonneContent: {
      type: Array,
      default: () => [],
    },
    hideRanking: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ranking () {
      if (this.isAssignedInOtherKolonne) {
        return 'red';
      }

      if (this.isNotAvailableInWeek) {
        return 'yellow';
      }

      return undefined;
    },

    rankingMessage () {
      if (this.isAssignedInOtherKolonne) {
        return `${this.$t('kolonne.label.assigned.to.other.kolonnen')} ${this.assignedKolonneNumbers.join(', ')}`
      }

      if (this.isNotAvailableInWeek) {
        return this.$t('kolonne.settings.notavailable');
      }

      return 'ist verfügbar';
    },
    
    qualificationsTitle () {
        let title = '';

        this.employee.qualifications.forEach((qualification, index) => {
            if (index > 0) {
                title += ', ';
            }
            title += qualification.name;
        });
        return title;
    },

    isAssignedInOtherKolonne () {
      return this.assignedKolonneNumbers.length > 1;
    },

    assignedKolonneNumbers () {
      return this.kolonneContent
        .filter(kolonne => [].concat(kolonne.employees_ids ?? []).includes(this.employee.id))
        .map(kolonne => kolonne.kolonne);
    },

    isNotAvailableInWeek () {
      return this.unavailabilitiesInWeek.length > 0
    },

    unavailabilitiesInWeek () {
      const startdate = new Date(this.startdate);
      const enddate = this.$moment(this.startdate).add(1, "Week").toDate();

      return this.employee.unavailabilities.filter(unavailability => {
        const date = new Date(unavailability.date.date)

        return date > startdate && date < enddate;
      })
    },
  },
};
</script>

<template>
  <div class="c-crew-settings-box__item">
    <div class="c-crew-settings-box__item-ranking">
        <span
        v-if="!hideRanking"
        :title="rankingMessage"
        :class="'c-ranking c-ranking--' + (ranking || 'transparent') ">
        </span>
    </div>
    <div class="c-crew-settings-box__item-name">
        <span :title="qualificationsTitle">
        {{ employee.firstName }} {{ employee.lastName }}
        </span>
    </div>
  </div>
</template>

